<template>
  <div>
    <div class="f-search-block">
      <div class="search-items">
        <div class="field-item">
          <div class="field-item-label">
            任务名称：
          </div>
          <div class="field-item-control">
            <el-input
              v-model="params.task_title"
              placeholder="请输入任务名称"
              class="input-m input-with-select"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="searchList"
              />
            </el-input>
          </div>
        </div>
      </div>
      <div class="search-btns">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="handelClickAdd"
        >
          新增任务
        </el-button>
        <el-button
          type="primary"
          plain
          @click="exportDialogVisible = true"
        >
          导出报表
        </el-button>
      </div>
    </div>

    <div class="f-table-block">
      <el-tabs
        v-model="params.time_type"
        @tab-click="searchList"
      >
        <el-tab-pane
          v-for="(item, index) in tabList"
          :key="index"
          :label="item.label"
          :name="item.name"
        />
      </el-tabs>
      <el-table
        v-loading="loadingTable"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          prop="task_title"
          label="任务名称"
        />
        <el-table-column
          prop="time"
          label="任务时间"
          min-width="300px"
        >
          <template slot-scope="scope">
            {{ scope.row.start_time_str }} - {{ scope.row.end_time_str }}
          </template>
        </el-table-column>
        <el-table-column
          prop="subtask_count"
          label="任务步骤"
        />
        <el-table-column label="任务状态">
          <template slot-scope="scope">
            <span v-if="scope.row.task_status === 1">{{ scope.row.time_type_desc }}</span>
            <span v-if="scope.row.task_status === 0">{{ scope.row.task_status_str }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="goEditItem(scope.row)"
            >
              查看
            </el-button>&nbsp;
            <el-button
              v-if="scope.row.task_status === 0 || scope.row.task_status === 1"
              type="text"
              size="small"
              @click="shelvesTask(scope.row)"
            >
              <span v-if="scope.row.task_status === 1">关闭</span>
              <span v-else>发布</span>
            </el-button>&nbsp;
            <el-button
              type="text"
              size="small"
              @click="handleListClick(scope.row)"
            >
              统计
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="table-pagination"
        background
        :current-page="params.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="params.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total_count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 任务统计弹窗 -->
    <el-dialog
      title="任务统计"
      :visible.sync="statisticsVisible"
      width="730px"
      :before-close="handleCloseStatistics"
    >
      <div class="statistics-top">
        <div class="statistical-left">
          <div class="statistics-title">
            {{ statisticsInfo.task_name }}
          </div>
          <div>{{ statisticsInfo.start_time }} 至 {{ statisticsInfo.end_time }}</div>
        </div>
        <div class="statistical-right">
          <div class="statistical-item">
            <div class="statistics-title">
              <span>{{ typeList[statisticsInfo.task_type] }}</span>
            </div>
            <div>任务类型</div>
          </div>
          <div class="statistical-item">
            <div class="statistics-title">
              {{ statisticsInfo.store_count }}
            </div>
            <div>参与门店</div>
          </div>
        </div>
      </div>
      <el-table
        v-loading="loadingStatistics"
        :data="statisticsInfo.task_list"
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="日期"
        />
        <el-table-column
          prop="join_people_count"
          label="参与人数"
        />
        <el-table-column
          prop="completion_count"
          label="完成次数"
        />
        <el-table-column
          prop="completion_people_count"
          label="完成人数"
        />
        <el-table-column label="完成率">
          <template slot-scope="scope">
            {{ scope.row.completion_rata }} %
          </template>
        </el-table-column>
        <el-table-column
          prop="click_people_count"
          label="触达人数"
        />
        <el-table-column label="触达率">
          <template slot-scope="scope">
            {{ scope.row.click_people_rate }} %
          </template>
        </el-table-column>
      </el-table>
      <div class="statistics-bottom">
        <el-button
          type="primary"
          size="medium"
          :loading="exportStatisticsLoading"
          @click="exportStatistics"
        >
          导出任务执行报表
        </el-button>
      </div>
    </el-dialog>

    <!-- 导出报表对话框 -->
    <SpExportList
      v-model="exportDialogVisible"
      :files-type="24"
    />
  </div>
</template>

<script>
import { getSalesperosnTask, shelvesTask, getStatistics } from '@/api/task/shoppingGuideTask'
export default {
  data () {
    return {
      loadingTable: false,
      tabList: [
        { label: '全部', name: '0' },
        { label: '未开始', name: '3' },
        { label: '进行中', name: '2' },
        { label: '已结束', name: '1' }
      ],
      tableData: [],
      params: {
        page: 1,
        page_size: 20,
        task_title: '',
        time_type: '0'
      },
      total_count: 0,
      statisticsVisible: false,
      statisticsInfo: {},
      loadingStatistics: false,
      exportDialogVisible: false,
      typeList: {
        1: '转发任务',
        2: '导购获客',
        3: '顾客下单',
        4: '会员福利'
      },
      statisticsTaskId: 0,
      exportStatisticsLoading: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList () {
      this.loadingTable = true
      const data = await getSalesperosnTask(this.params)
      if (data) {
        this.tableData = data.list
        this.total_count = data.total_count
        this.loadingTable = false
      }
    },

    // 查询列表
    searchList () {
      this.params.page = 1
      this.getList()
    },

    // 查看统计
    async handleListClick (item) {
      this.statisticsVisible = true
      this.loadingStatistics = true
      let taskId = item.task_id
      this.statisticsTaskId = taskId
      const data = await getStatistics(taskId, { taskId })
      if (data) {
        this.statisticsInfo = data
        this.loadingStatistics = false
      }
    },

    handleCloseStatistics () {
      this.statisticsVisible = false
    },

    // 查看任务详情
    goEditItem (item) {
      this.$router.push({ path: '/task/shoppingGuideTask/' + item.task_id })
    },

    // 关闭开启任务
    shelvesTask (row) {
      let task_status = row.task_status
      let message = task_status === 1 ? '终止' : '开启'
      this.$confirm('此操作将' + message + '该任务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: task_status === 1 ? 'warning' : ''
      })
        .then(async () => {
          let taskId = row.task_id
          const data = await shelvesTask(taskId, {
            taskId,
            task_status: row.task_status === 1 ? 0 : 1
          })
          if (data) {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功'
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    // 分页
    handleSizeChange (val) {
      this.params.page = 1
      this.params.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getList()
    },

    // 新增任务
    handelClickAdd () {
      this.$router.push({ path: '/task/shoppingGuideTask/0' })
    },

    // 按导购维度导出报表
    async exportStatistics () {
      this.exportStatisticsLoading = true
      const data = await this.$api.task.exportStatistics(this.statisticsTaskId).catch((v) => {
        this.exportStatisticsLoading = false
      })
      if (data) {
        this.exportStatisticsLoading = false
        this.$message({
          message: '请求成功，异步处理中，请稍后到 导出列表 进行下载！',
          type: 'success'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btns {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.statistics-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background: rgba(239, 239, 239, 1);
  border-radius: 5px;
  padding: 15px 20px;
  color: #999999;
  font-size: 12px;
  .statistical-right {
    display: flex;
    .statistical-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &:first-child {
        margin-right: 50px;
      }
    }
  }
}
.statistics-bottom {
  margin-top: 20px;
}
.statistics-title {
  font-size: 16px;
  color: #606266;
}
</style>
